<template>
  <div class="footer-column">
    <h5 v-if="title" class="footer-title">{{ title }}</h5>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FooterColumn',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.footer-column {
  display: flex;
  flex-direction: column;
  animation: fadeInUp 0.6s ease-out;
  animation-fill-mode: both;
}

.footer-column:nth-child(1) {
  animation-delay: 0.1s;
}

.footer-column:nth-child(2) {
  animation-delay: 0.2s;
}

.footer-column:nth-child(3) {
  animation-delay: 0.3s;
}

.footer-column:nth-child(4) {
  animation-delay: 0.4s;
}

.footer-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #ffffff;
  position: relative;
  padding-bottom: 0.75rem;
  letter-spacing: 0.5px;
}

.footer-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 3px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.8), transparent);
  border-radius: 2px;
  transition: width 0.3s ease;
}

.footer-column:hover .footer-title::after {
  width: 100%;
}

@media (max-width: 768px) {
  .footer-title {
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

